/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* Represents attributes that are copied (projected) from the table into the local secondary index.
*/
export class AwsDynamoDbSnapshotPropertiesLocalSecondaryIndexesInnerProjection {
  /**
  * The set of attributes that are projected into the index.
  */
  'projectionType'?: string;
  /**
  * Represents the non-key attribute names which will be projected into the index.
  */
  'nonKeyAttributes'?: Array<string>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "projectionType",
      "baseName": "projectionType",
      "type": "string",
      "format": ""
    },
    {
      "name": "nonKeyAttributes",
      "baseName": "nonKeyAttributes",
      "type": "Array<string>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return AwsDynamoDbSnapshotPropertiesLocalSecondaryIndexesInnerProjection.attributeTypeMap;
  }

  public constructor() {
  }
}

